/* eslint-disable */
import React, { useState, useEffect, memo } from 'react'
import { useRouteMatch } from "react-router-dom"
import styled from 'styled-components'
import { getImage, getImageError } from 'estimate_list/libs/item'
import { useDispatch, useSelector } from 'react-redux'
import { MEDIUM_GUIDE_REQUEST } from 'estimate_list/reducers/medium'
import { Api } from 'estimate_list/libs/api'
import { estimate, scrollTo } from 'estimate_list/libs/util'
import { setEstimateItems } from 'estimate_list/libs/action'
import Item from './item'
import SEO from "../../libs/seo";

function Mguide(props) {
    const { selectCategory, domain, loading } = useSelector(state => state.initial)
    const { mediumGuide } = useSelector(state => state.medium)
    const [itemList, setItemList] = useState([])

    const dispatch = useDispatch()

    const match = useRouteMatch()

    const returnCategory = () => {
        let cate = '1010100000'
        const firstPathName = window.location.pathname.split('/')[1]
        if (firstPathName === 'list') {
            cate = window.location.pathname.split('/')[2]
        }
        return cate
    }

    useEffect(() => {
        fetchMediumGuide()
    }, [])

    useEffect(() => {
        if (!loading.setSearchDataOption && mediumGuide) {
            setTimeout(() => {
                autoScroll()
            }, 500)
        }
    }, [loading.setSearchDataOption, mediumGuide])

    useEffect(() => {
        if (mediumGuide && mediumGuide.itemCount > 0) {
            const item = mediumGuide.itemList.map(v => v.item_id)
            fetchItemList(item)
        }
    }, [mediumGuide])

    const fetchMediumGuide = () => {
        dispatch({
            type: MEDIUM_GUIDE_REQUEST,
            data: selectCategory?selectCategory:returnCategory()
        })
    }

    const fetchItemList = (items) => {
        let params = {}
        let body = { items: items.join(',') }

        Api.getItemsParam(params, body).then(response => {
            if (response.data.code.toString() === '200') {
                let items = response.data.data.list
                let itemList = {}
                items.map(v => {
                    itemList[v.item_id] = v
                    return true
                })
                setItemList(itemList)
            }
        })
    }

    const addEstimateItem = (itemId) => {
        let estimateItems = estimate.addEstimateItem(itemId)
        dispatch(setEstimateItems({ estimateItems, type: 'add', itemId: itemId }))
        scrollTo('#estimateList')
    }

    const autoScroll = () => {
        scrollTo('#nav_spy', -71)
    }

    const itemComponent = (itemData) => {
        if (itemList[itemData[0]] === undefined) return null
        let item = itemList[itemData[0]]
        let thumbnail = getImage(item.cate_id, item.item_id, 300)

        let categoryDiv = domain === 'shopping' ? 1 : 0 // 0 견적 1 쇼핑

        return (
            <ContentItem key={item.item_id}>
                <a name={'key' + item.item_id}>
                    <h3 className="tit-h3">{itemData[2]}</h3>
                </a>

                <div className="mediumguide_contents_conts_article_img">
                    <a href={`${process.env.REACT_APP_SHOPPING_URL}/${item.cate_id}/${item.item_id}/`} target="_blank">
                        <img
                            src={thumbnail.imgUrl}
                            onError={e => getImageError(e, thumbnail.noImgUrl)}
                            alt={item.item_name}
                        />
                    </a>
                </div>

                <div className="button-group ctr">
                    {categoryDiv === 1 && item.price > 0 && (
                        <>
                            {/* <button type="button" className="btn_item_add" onClick={() => this.addCartItem(item)}>
                                <i className="icon-in" /> 장바구니 담기
                            </button> */}
                        </>
                    )}
                    {categoryDiv === 0 && item.price > 0 && (
                        <button
                            type="button"
                            className="btn_item_add"
                            onClick={() => addEstimateItem(item.item_id)}
                        >
                            <i className="icon-in" /> 상품 견적담기
                        </button>
                    )}
                    <a
                        href={`${process.env.REACT_APP_SHOPPING_URL}/${item.cate_id}/${item.item_id}/`}
                        target="_blank"
                        className="btn_item_detail"
                    >
                        상품 상세보기 <i className="icon-angle-right" />
                    </a>
                </div>
            </ContentItem>
        )
    }

    return (
        mediumGuide && (
            <>
                {props.cateName != null && (
                    <>
                        {domain === 'shopping' && (
                            <>
                                {match.path === '/list/:categoryID/mguide' && (
                                    <SEO
                                        title={`${props.cateName} 미디엄가이드 : 행복쇼핑 가격비교`}
                                        description={`${props.cateName} 미디엄가이드 : 최저가 보장 가격비교 사이트, 온라인 쇼핑몰 비교는 행복쇼핑`}
                                        ogTitle={`${props.cateName} 미디엄가이드 : 행복쇼핑 가격비교`}
                                        ogSiteName={`${props.cateName} 미디엄가이드 : 행복쇼핑 가격비교`}
                                    />
                                )}
                            </>
                        )}
                        {domain === 'pc' && (
                            <>
                                {match.path === '/list/:categoryID/mguide' && (
                                    <SEO
                                        title={`${props.cateName} 미디엄가이드 PC견적 : 행복쇼핑`}
                                        description={`${props.cateName} 미디엄가이드 PC견적 : 최저가 보장 가격비교 사이트, 온라인 쇼핑몰 비교는 행복쇼핑`}
                                        ogTitle={`${props.cateName} 미디엄가이드 PC견적 : 행복쇼핑`}
                                        ogSiteName={`${props.cateName} 미디엄가이드 PC견적 : 행복쇼핑`}
                                    />
                                )}
                            </>
                        )}
                    </>
                )}
                <Style>
                    <div className="mediumguide_head">
                        <h2 className="tit-h2">
                            <img
                                src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v3/tit_estimate_mediumguide.png`}
                                alt="행복쇼핑이 제안하는 구매의 기준! 미디엄 가이드"
                            />
                        </h2>
                    </div>
                    {mediumGuide.itemList.length > 0 && (
                        <div className="item_group">
                            {mediumGuide.itemList.map((v, i) => {
                                let itemId = v.item_id
                                let item = itemList[itemId]
                                return <Item key={i} setItem={item} itemMedium={v} />
                            })}
                        </div>
                    )}
                    {mediumGuide.contentTitle ? (
                        <div className="mediumguide_contents">
                            <div className="mediumguide_contents_body">
                                <div className="mediumguide_contents_headline">
                                    <p className="subject"><strong>{mediumGuide.contentTitle}</strong></p>
                                    <span className="date">기사입력 {mediumGuide.content_regdate}</span>
                                </div>
                            </div>
                            <div className="mediumguide_contents_conts">
                                {mediumGuide.contenttxt.map((v, k) => {
                                    if (typeof v === 'object') {
                                        return <div key={k}>{itemComponent(v)}</div>
                                    } else {
                                        return <div key={k} dangerouslySetInnerHTML={{ __html: v }} />
                                    }
                                })}
                            </div>
                        </div>
                    ) : (
                        <div className="no_content">
                            <div><img src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v3/img_happyshopping_ci_simbol.png`} alt="" /></div>
                            <p><b>미디엄 가이드</b> 준비중 입니다.</p>
                        </div>
                    )}
                </Style>
            </>
        )
    )
}

const Style = styled.div`
    min-height: 600px;

    .mediumguide_head {
        height: 156px;
        padding: 42px 0 0 13px;
        background: ${'url('+ process.env.REACT_APP_CDN_IMG +'/img_static/img_pres/_v3/bg_estimate_mediumguide_head.png) no-repeat 97% 100%'};
    }
    .mediumguide_contents_headline {
        padding: 20px 0 10px;
        border-bottom: 2px solid #0f4f9f;
        margin: 20px 0 0;

        .subject {
            font-size: 30px;
            color: #000;
            line-height: 1.2;
        }
        .date {
            display: block;
            margin-top: 12px;
            color: #999;
        }
    }
    .mediumguide_contents_conts {
        padding: 30px 0 40px;
        font-size: 15px;
        line-height: 2;

        img {
            max-width: 100%;
            height: auto
        }
    }
    .no_content {
        text-align: center;
        padding: 140px 0 0;

        div {
            margin: 0 0 5px;
        }
        p {
            font-size: 16px;
        }
    }
`

const ContentItem = styled.div`
    .tit-h3 {
        margin-bottom: 15px;
        font-size: 18px;
        color: #000;
        text-align: center;
    }
    .mediumguide_contents_conts_article_img {
        text-align: center;
        img {
            max-width: 100%;
        }
    }
    .button-group {
        margin-top: 25px;
        font-size: 0;

        &.ctr {
            text-align: center;
        }
        .btn_item_add {
            font-size: 12px;
            font-weight: bold;
            width: 122px;
            height: 30px;
            border: 0;
            color: #fff;
            background-color: #418ded;
            vertical-align: middle;
            letter-spacing: 0;
            cursor: pointer;

            [class^="icon-"] {
                margin-right: 5px;
                font-size: 16px;
                vertical-align: -1px;
            }
        }
        .btn_item_detail {
            display: inline-block;
            margin-left: 10px;
            font-size: 12px;
            font-weight: bold;
            width: 122px;
            height: 30px;
            border: 1px solid #ccc;
            background-color: #fff;
            text-align: center;
            line-height: 28px;
            vertical-align: middle;
            letter-spacing: 0;
            cursor: pointer;
            box-sizing: border-box;
        }
    }
`

export default memo(Mguide)



// WEBPACK FOOTER //
// ./src/estimate_list/components/medium/mguide.js